import { Box } from "@mui/material";
import { ChartTypeControl } from "./controls/ChartTypeControl";
import { AssetTypeControl } from "./controls/AssetTypeControl";
import { ComparisonControl } from "./controls/ComparisonControl";
import { MobileRangeControl } from "./controls/MobileRangeControl";
import { useChartControls } from "./ChartControlsContext";

// Phones draw the chart without the navigator: the range is one calendar
// button at the end of the chart type's tab line, the rest sits below.
export const ChartControlsMobileTop = () => {
  const { controls } = useChartControls();

  return controls.showChartType ? (
    <ChartTypeControl action={<MobileRangeControl />} />
  ) : (
    <MobileRangeControl />
  );
};

export const ChartControlsMobileBar = () => (
  <Box pb={2} data-testid="chart-controls-mobile-bar">
    <AssetTypeControl scrollable />
    <ComparisonControl fullWidth />
  </Box>
);
